import { BASE_URL } from '../constants/Constants';
import axiosInstance from './axiosInstance'

export const getUserById = async (userId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/userprofile/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user by id:", error);
    throw error;
  }
};

export const getUserByEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/userprofile/email?email=${email}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

export const addUser = async (payload) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/userprofile`, payload);
    return response.data.body;
  } catch (error) {
    console.error('Error adding user:', error);
    throw error;
  }
};

export const updateUser = async (payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/userprofile/update-user`, payload);
    return response.data.body;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const validateUser = async (payload)=>{
  try {
    const response = await axiosInstance.post(`${BASE_URL}/userprofile/validate-user`,payload);    
    return response.data;
  } catch (error) {
    console.error('Error validating user', error);
    return error.response.data;
    //throw error;
  }
}